module.exports = __webpack_public_path__ + "img/intl-app-logo.0d092d2.png";